<svg class="logo" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 157 210">
	<path
		stroke="currentColor"
		stroke-linecap="round"
		stroke-linejoin="round"
		stroke-width="4"
		d="M52 208a50.348 50.348 0 0 0 30.617-10.362c8.764-6.716 15.027-16.124 17.805-26.746M52 208a50.347 50.347 0 0 1-30.617-10.362c-8.764-6.716-15.027-16.124-17.805-26.746M52 208c13.805 0 25-22.165 25-49.5S65.805 109 52 109m0 99c-13.806 0-25-22.165-25-49.5S38.194 109 52 109m48.422 61.892A49.263 49.263 0 0 0 102 158.5a48.89 48.89 0 0 0-6.428-24.299m4.85 36.691A100.343 100.343 0 0 1 52 183.25c-17.567 0-34.072-4.482-48.422-12.358m0 0A49.121 49.121 0 0 1 2 158.5a48.888 48.888 0 0 1 6.428-24.299M52 109a50.363 50.363 0 0 1 25.234 6.757 49.725 49.725 0 0 1 18.338 18.444M52 109a50.363 50.363 0 0 0-25.234 6.757 49.725 49.725 0 0 0-18.338 18.444m87.144 0C83.476 144.574 68.002 150.273 52 150.25c-16.656 0-31.889-6.05-43.572-16.049"
	/>
	<g filter="url(#a)">
		<path
			fill="#E64980"
			d="M14 3v11.18Zm0 161.5V92.433Zm0-72.067 20.602-5.164a66.812 66.812 0 0 1 46.17 5.082l.804.403a66.81 66.81 0 0 0 45.264 5.291L150 92.59a362.4 362.4 0 0 1-.037-78.247l-23.13 5.456a66.812 66.812 0 0 1-45.257-5.3l-.803-.402a66.811 66.811 0 0 0-46.171-5.083L14 14.18m0 78.254V14.18Z"
		/>
		<path
			stroke="currentColor"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="5"
			d="M14 3v11.18m0 0 20.602-5.166a66.811 66.811 0 0 1 46.17 5.083l.804.403a66.812 66.812 0 0 0 45.257 5.299l23.13-5.456A362.4 362.4 0 0 0 150 92.59l-23.16 5.455a66.81 66.81 0 0 1-45.264-5.291l-.803-.403a66.812 66.812 0 0 0-46.171-5.082L14 92.433m0-78.254v78.254m0 72.067V92.433"
		/>
	</g>
	<path
		stroke="currentColor"
		stroke-linecap="round"
		stroke-linejoin="round"
		stroke-miterlimit="10"
		stroke-width="5"
		d="M93.252 39.914c1.129 0 2.257.226 3.386.678 1.129.451 2.032 1.128 2.935 2.031.903.903 1.58 1.806 2.031 2.935.452 1.128.677 2.257.677 3.386 0 1.128-.225 2.257-.677 3.386-.451 1.129-1.128 2.031-2.031 2.934l-2.258 2.483-2.483 2.483-2.257 2.258-2.483 2.483c-.903.903-1.806 1.58-2.935 2.032-1.129.451-2.257.677-3.386.677s-2.257-.226-3.386-.677c-1.129-.452-2.032-1.13-2.934-2.032-.903-.903-1.58-1.806-2.032-2.935-.451-1.128-.677-2.257-.677-3.611 0-1.129.225-2.258.677-3.386.451-1.13 1.129-2.032 2.032-2.935l2.483-2.483"
	/>
	<path
		stroke="currentColor"
		stroke-linecap="round"
		stroke-linejoin="round"
		stroke-miterlimit="10"
		stroke-width="5"
		d="M70.227 69.034c-1.129 0-2.257-.226-3.386-.677-1.129-.451-2.032-1.129-2.934-2.032-.903-.903-1.58-1.806-2.032-2.934-.452-1.129-.677-2.258-.677-3.386 0-1.129.225-2.258.677-3.386.451-1.129 1.129-2.032 2.032-2.935l2.257-2.483 2.483-2.483 2.483-2.483 2.483-2.483c.903-.903 1.806-1.58 2.935-2.032 1.128-.451 2.257-.677 3.386-.677 1.128 0 2.257.226 3.386.677 1.128.452 2.031 1.129 2.934 2.032s1.58 1.806 2.032 2.934c.451 1.13.677 2.258.677 3.386 0 1.13-.226 2.258-.677 3.386-.452 1.13-1.129 2.032-2.032 2.935l-2.483 2.709"
	/>
	<defs>
		<filter
			id="a"
			width="149"
			height="174.5"
			x="7.5"
			y=".5"
			color-interpolation-filters="sRGB"
			filterUnits="userSpaceOnUse"
		>
			<feFlood flood-opacity="0" result="BackgroundImageFix" />
			<feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
			<feOffset dy="4" />
			<feGaussianBlur stdDeviation="2" />
			<feComposite in2="hardAlpha" operator="out" />
			<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
			<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1_39" />
			<feBlend in="SourceGraphic" in2="effect1_dropShadow_1_39" result="shape" />
		</filter>
	</defs>
</svg>
